import { FormEvent, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AuthLayout from '../../components/layout/AuthLayout';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const from = (location.state as { from?: string } | null)?.from || '/sites';

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : '登录失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="欢迎回来" subtitle="登录后查看站点访问数据与实时访客。">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <label className="block">
          <span className="text-sm font-medium text-foreground-800">邮箱</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="mt-1.5 w-full px-4 py-3 rounded-md border border-background-200 bg-background-50 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-foreground-800">密码</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="至少 6 位"
            className="mt-1.5 w-full px-4 py-3 rounded-md border border-background-200 bg-background-50 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300"
          />
        </label>
        {error && <p className="text-sm text-primary-700">{error}</p>}
        <button
          type="submit"
          disabled={submitting}
          className="mt-1 w-full py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md disabled:opacity-60"
        >
          {submitting ? '登录中…' : '登录'}
        </button>
      </form>
      <p className="mt-6 text-sm text-foreground-600">
        还没有账号？{' '}
        <Link to="/register" className="font-semibold text-primary-600 hover:text-primary-700">
          免费注册
        </Link>
        {' · '}
        <Link to="/forgot" className="font-semibold text-primary-600 hover:text-primary-700">
          忘记密码
        </Link>
      </p>
    </AuthLayout>
  );
}
